import { getDate, getMonth, getYear } from 'date-fns';
import { formatDate } from '../../utils/dateUtils';

export type Period = { start: Date; end: Date };

const isCalendarYear = ({ start, end }: Period) =>
  getYear(start) === getYear(end) &&
  getMonth(start) === 0 &&
  getDate(start) === 1 &&
  getMonth(end) === 11 &&
  getDate(end) === 31;

// A calendar year reads better without repeating the year on both ends ("January to December 2026").
// Any other period needs it on both, because it may well cross a year boundary.
export const formatPeriodBounds = (period: Period) =>
  isCalendarYear(period)
    ? {
        start: formatDate(period.start, 'MMMM'),
        end: formatDate(period.end, 'MMMM yyyy'),
      }
    : {
        start: formatDate(period.start, 'MMMM yyyy'),
        end: formatDate(period.end, 'MMMM yyyy'),
      };
